module.exports = __webpack_public_path__ + "static/media/BD.6ab6bba3.svg";